// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
    position: fixed;
    /* Fix the header to the top */
    top: 0;
    width: 100%;
    /* Full width */
    background-color: #ffffff;
    /* Background color */
    z-index: 1000;
    /* Ensure it's on top of other content */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    /* Add shadow for a subtle effect */
}

/* @media screen and (max-width: 480px) {
    .header { 
        width: 25%; 
    }
} */




.navbar-toggler {
    border: none;
    /* Remove default button border */
    background-color: transparent;
    /* Make the button background transparent */
    outline: none;
    /* Remove focus outline */
}

.navbar-toggler-icon {
    color: #000000;
    /* Color of the toggle icon */
}

.navbar-nav .nav-item {
    margin-right: 20px;
    /* Add spacing between list items */
}

.nav-link {
    color: #000000;
    /* Text color of navbar links */
    text-decoration: none;
    /* Remove underline from links */
}

.nav-link:hover {
    color: #007bff;
    /* Change text color on hover */
}

.dropdown-menu {
    background-color: #ffffff;
    /* Background color of dropdown menu */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    /* Add shadow for dropdown */
}

.dropdown-item {
    color: #000000;
    /* Text color of dropdown items */
}

.dropdown-item:hover {
    background-color: #f8f9fa;
    /* Change background color on hover */
}

.navbar-toggler {
    border: none;
    background-color: #e3dada;
    outline: none;
}

.navbar-toggler .navbar-toggler-icon {
    background-image: var(--bs-navbar-toggler-icon-bg) !important;
}

.navbar-brand img {
    width: 175px;
    height: auto;
}

img.logo-img {
  
 
    height: auto;
    width: 205px;
    cursor: pointer;
}

.location-drop {
    width: 30% !important;
}


/* .product-image {

    width: 90%;

    height: 84%;
} */


.no-spinner::-webkit-inner-spin-button,
.no-spinner::-webkit-outer-spin-button {
  appearance: none; 
  margin: 0;
}
.sidebar-container {
    display: flex;
}

.g-sidenav-show {
    flex-basis: 240px; /* Initial width of the sidebar */
    transition: flex-basis 0.3s ease; /* Smooth transition when changing width */
}

.g-sidenav-hidden {
    flex-basis: 80px; /* Reduced width of the sidebar */
}

.main-content {
    flex-grow: 1; /* Take remaining space */
    transition: margin-left 0.3s ease; /* Adjust main content when sidebar width changes */
}

/* Adjust margin when sidebar is hidden */
.g-sidenav-hidden .main-content {
    margin-left: 80px; /* Same as reduced sidebar width */
}
/* .navbar-vertical.navbar-expand-xs{

    width:350px;
} */
.navbar-vertical.navbar-expand-xs.shrink{

    width:50px;
}
@media only screen and (max-width: 468px) {
    
    .location-drop {
        width: 60% !important;
    }
}
/* // remove the icon in header  */
.no-arrow {
    appearance: none;
    background: none;
    padding-right: 20px; /* Adjust as needed */
    position: relative;
  }
  
  /* Optional: Custom arrow styling */
  .no-arrow::after {
    content: '▼'; /* Unicode character for a downward arrow */
    font-size: 12px;
    color: #000; /* Adjust color as needed */
    position: absolute;
    right: 10px; /* Adjust as needed */
    pointer-events: none;
  }
  
  /* Optional: Hide custom arrow for now */
  .no-arrow::after {
    display: none;
  }`, "",{"version":3,"sources":["webpack://./src/View/LandingPage/Main/header.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,8BAA8B;IAC9B,MAAM;IACN,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,aAAa;IACb,wCAAwC;IACxC,wCAAwC;IACxC,mCAAmC;AACvC;;AAEA;;;;GAIG;;;;;AAKH;IACI,YAAY;IACZ,iCAAiC;IACjC,6BAA6B;IAC7B,2CAA2C;IAC3C,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB,sCAAsC;IACtC,wCAAwC;IACxC,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;;;IAGI,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;;AAGA;;;;;GAKG;;;AAGH;;EAGE,gBAAgB;EAChB,SAAS;AACX;AACA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB,EAAE,iCAAiC;IACpD,gCAAgC,EAAE,0CAA0C;AAChF;;AAEA;IACI,gBAAgB,EAAE,iCAAiC;AACvD;;AAEA;IACI,YAAY,EAAE,yBAAyB;IACvC,iCAAiC,EAAE,mDAAmD;AAC1F;;AAEA,yCAAyC;AACzC;IACI,iBAAiB,EAAE,kCAAkC;AACzD;AACA;;;GAGG;AACH;;IAEI,UAAU;AACd;AACA;;IAEI;QACI,qBAAqB;IACzB;AACJ;AACA,kCAAkC;AAClC;IAGI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB,EAAE,qBAAqB;IAC1C,kBAAkB;EACpB;;EAEA,mCAAmC;EACnC;IACE,YAAY,EAAE,2CAA2C;IACzD,eAAe;IACf,WAAW,EAAE,2BAA2B;IACxC,kBAAkB;IAClB,WAAW,EAAE,qBAAqB;IAClC,oBAAoB;EACtB;;EAEA,wCAAwC;EACxC;IACE,aAAa;EACf","sourcesContent":[".header {\n    position: fixed;\n    /* Fix the header to the top */\n    top: 0;\n    width: 100%;\n    /* Full width */\n    background-color: #ffffff;\n    /* Background color */\n    z-index: 1000;\n    /* Ensure it's on top of other content */\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    /* Add shadow for a subtle effect */\n}\n\n/* @media screen and (max-width: 480px) {\n    .header { \n        width: 25%; \n    }\n} */\n\n\n\n\n.navbar-toggler {\n    border: none;\n    /* Remove default button border */\n    background-color: transparent;\n    /* Make the button background transparent */\n    outline: none;\n    /* Remove focus outline */\n}\n\n.navbar-toggler-icon {\n    color: #000000;\n    /* Color of the toggle icon */\n}\n\n.navbar-nav .nav-item {\n    margin-right: 20px;\n    /* Add spacing between list items */\n}\n\n.nav-link {\n    color: #000000;\n    /* Text color of navbar links */\n    text-decoration: none;\n    /* Remove underline from links */\n}\n\n.nav-link:hover {\n    color: #007bff;\n    /* Change text color on hover */\n}\n\n.dropdown-menu {\n    background-color: #ffffff;\n    /* Background color of dropdown menu */\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    /* Add shadow for dropdown */\n}\n\n.dropdown-item {\n    color: #000000;\n    /* Text color of dropdown items */\n}\n\n.dropdown-item:hover {\n    background-color: #f8f9fa;\n    /* Change background color on hover */\n}\n\n.navbar-toggler {\n    border: none;\n    background-color: #e3dada;\n    outline: none;\n}\n\n.navbar-toggler .navbar-toggler-icon {\n    background-image: var(--bs-navbar-toggler-icon-bg) !important;\n}\n\n.navbar-brand img {\n    width: 175px;\n    height: auto;\n}\n\nimg.logo-img {\n  \n \n    height: auto;\n    width: 205px;\n    cursor: pointer;\n}\n\n.location-drop {\n    width: 30% !important;\n}\n\n\n/* .product-image {\n\n    width: 90%;\n\n    height: 84%;\n} */\n\n\n.no-spinner::-webkit-inner-spin-button,\n.no-spinner::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  appearance: none; \n  margin: 0;\n}\n.sidebar-container {\n    display: flex;\n}\n\n.g-sidenav-show {\n    flex-basis: 240px; /* Initial width of the sidebar */\n    transition: flex-basis 0.3s ease; /* Smooth transition when changing width */\n}\n\n.g-sidenav-hidden {\n    flex-basis: 80px; /* Reduced width of the sidebar */\n}\n\n.main-content {\n    flex-grow: 1; /* Take remaining space */\n    transition: margin-left 0.3s ease; /* Adjust main content when sidebar width changes */\n}\n\n/* Adjust margin when sidebar is hidden */\n.g-sidenav-hidden .main-content {\n    margin-left: 80px; /* Same as reduced sidebar width */\n}\n/* .navbar-vertical.navbar-expand-xs{\n\n    width:350px;\n} */\n.navbar-vertical.navbar-expand-xs.shrink{\n\n    width:50px;\n}\n@media only screen and (max-width: 468px) {\n    \n    .location-drop {\n        width: 60% !important;\n    }\n}\n/* // remove the icon in header  */\n.no-arrow {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background: none;\n    padding-right: 20px; /* Adjust as needed */\n    position: relative;\n  }\n  \n  /* Optional: Custom arrow styling */\n  .no-arrow::after {\n    content: '▼'; /* Unicode character for a downward arrow */\n    font-size: 12px;\n    color: #000; /* Adjust color as needed */\n    position: absolute;\n    right: 10px; /* Adjust as needed */\n    pointer-events: none;\n  }\n  \n  /* Optional: Hide custom arrow for now */\n  .no-arrow::after {\n    display: none;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
